<template>

    <nav class="main-header navbar navbar-expand navbar-white navbar-light">
        <!-- Left navbar links -->
        <ul class="navbar-nav">
            <li class="nav-item">
                <a class="nav-link sidebar-toggle-btn" data-widget="pushmenu" href="#" role="button"><i class="fas fa-bars"></i></a>
            </li>
            <li class="nav-item d-none d-sm-inline-block">
                <a href="/" class="nav-link" target="_blank" >{{ $t('hi.website') }}</a>
            </li>
        </ul>

    </nav>
</template>

<script>
export default {
    name: "Navbar"
}

$(document).ready(function(){
    $('.sidebar-toggle-btn').PushMenu();
});

</script>

<style scoped>


</style>
